import { render, staticRenderFns } from "./Son_Password.vue?vue&type=template&id=cf5ce144&scoped=true&"
import script from "./Son_Password.vue?vue&type=script&lang=js&"
export * from "./Son_Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ce144",
  null
  
)

export default component.exports